//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'IntegralMask',
  props: {
    scoreNum: {
      type: Number,
      default: 10
    },
    // us: {}
    duration: {
      type: Number,
      default: 1000
    },
    score: {
      type: Number,
      required: true
    },
    action: {
      type: String,
      default: '点赞'
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.closeMask()
  },
  methods: {
    closeMask () {
      const timmer = setTimeout(() => {
        this.$_IntegralMask.close()
      }, this.duration)
      this.$once('hook:beforeDestory', () => {
        clearTimeout(timmer)
      })
    }
  },
  created () {
    
  },
  components: {
  }
}



// WEBPACK FOOTER //
// ./src/plugin/IntegralMask/src/main.vue